<template>
  <div id="app" :data-version="version">
    <b-container fluid>
      <b-row>
        <b-col v-show="$route.path != '/login'" class="app-sidebar">
          <page-sidebar @logout="logout" />
        </b-col>
        <b-col class="app-content">
          <div v-show="mostrarBannerDePruebas" class="banner-zona-pruebas" title="Para que lo tengas en cuenta">
            <span>ZONA DE PRUEBAS</span>
          </div>
          <router-view />
        </b-col>
      </b-row>
    </b-container>
    <b-alert v-if="updateAvailable" show variant="warning" class="version-update-alert">
      <span>Hay una nueva versión disponible.</span>
      <b-button size="sm" variant="warning" class="ml-3" @click="reload">Recargar</b-button>
    </b-alert>
    <page-loading :active="loading" />
    <flash-modal />
  </div>
</template>

<script>
import PageSidebar from "@/views/common/sidebar/sidebar.vue";
import { mapState } from "pinia";
import { useLoadingStore } from "@/stores/loading";
import { useSessionStore } from "@/stores/SessionStore";
import { useVersionStore } from "@/stores/VersionStore";

import FlashModal from "@/views/common/FlashModal";

export default {
  components: {
    PageSidebar,
    FlashModal,
  },
  computed: {
    ...mapState(useLoadingStore, ["loading"]),
    ...mapState(useSessionStore, ["mostrarBannerDePruebas"]),
    ...mapState(useVersionStore, ["updateAvailable"]),
    version() {
      return "v" + process.env.VUE_APP_VERSION;
    },
  },
  methods: {
    reload() {
      const versionStore = useVersionStore();
      versionStore.reload();
    },
    logout() {
      const sessionStore = useSessionStore();
      sessionStore.logout().then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.version-update-alert {
  align-items: center;
  bottom: 1rem;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  left: 50%;
  margin: 0;
  max-width: calc(100% - 2rem);
  position: fixed;
  transform: translateX(-50%);
  width: 28rem;
  z-index: 1100;
}
</style>
